import type { IAccountNotificationsTasks } from './AccountNotificationsTasks.interface';
import AccountNotificationsPreferences from './AccountNotificationsPreferences';

export default class AccountNotificationsTasks implements IAccountNotificationsTasks {
  newTask: AccountNotificationsPreferences;
  taskCompleted: AccountNotificationsPreferences;
  taskDueDateAhead: AccountNotificationsPreferences;
  taskDueDate: AccountNotificationsPreferences;
  taskOverdue: AccountNotificationsPreferences;

  static build = (data: IAccountNotificationsTasks) => new AccountNotificationsTasks(data);
  static blank = () => new AccountNotificationsTasks();

  /**
   * Constructor
   * @param {IAccountNotificationsTasks} data
   */
  constructor(data?: IAccountNotificationsTasks) {
    this.newTask = new AccountNotificationsPreferences(data?.newTask);
    this.taskCompleted = new AccountNotificationsPreferences(data?.taskCompleted);
    this.taskDueDateAhead = new AccountNotificationsPreferences(data?.taskDueDateAhead);
    this.taskDueDate = new AccountNotificationsPreferences(data?.taskDueDate);
    this.taskOverdue = new AccountNotificationsPreferences(data?.taskOverdue);
  }
}
